export enum STATUSES {
  AVAILABLE = "available",
  SUSPENSION = "suspension",
}

export enum STATUSES_CONFIRM {
  CONFIRMED = "confirmed",
  UNCONFIRMED = "unconfirmed",
}

export const STATUS_NAME = {
  [STATUSES.AVAILABLE]: "利用可能",
  [STATUSES.SUSPENSION]: "利用停止",
};

export const STATUS_CONFIRM_NAME = {
  [STATUSES_CONFIRM.CONFIRMED]: "確認済み",
  [STATUSES_CONFIRM.UNCONFIRMED]: "未確認",
};

export const STATUS_ARRAY = [
  { id: STATUSES.AVAILABLE, name: STATUS_NAME[STATUSES.AVAILABLE] },
  { id: STATUSES.SUSPENSION, name: STATUS_NAME[STATUSES.SUSPENSION] },
];

export const STATUS_CONFIRM_ARRAY = [
  {
    id: STATUSES_CONFIRM.CONFIRMED,
    name: STATUS_CONFIRM_NAME[STATUSES_CONFIRM.CONFIRMED],
  },
  {
    id: STATUSES_CONFIRM.UNCONFIRMED,
    name: STATUS_CONFIRM_NAME[STATUSES_CONFIRM.UNCONFIRMED],
  },
];

export enum TYPES {
  CONSUMER = "consumer",
  BUSINESS = "business",
  MANIA = "mania",
  EVENT = "event",
}

export const TYPES_NAME = {
  [TYPES.CONSUMER]: "一般会員",
  [TYPES.BUSINESS]: "業者会員",
  [TYPES.MANIA]: "愛好家",
  [TYPES.EVENT]: "店舗会員",
};

export const TYPES_ARRAY = [
  { id: TYPES.CONSUMER, name: TYPES_NAME[TYPES.CONSUMER] },
  { id: TYPES.BUSINESS, name: TYPES_NAME[TYPES.BUSINESS] },
  { id: TYPES.MANIA, name: TYPES_NAME[TYPES.MANIA] },
  { id: TYPES.EVENT, name: TYPES_NAME[TYPES.EVENT] },
];

export enum LANGUAGES {
  JP = "jp",
  EN = "en",
  CN = "cn",
}

export const LANGUAGES_NAME = {
  [LANGUAGES.JP]: "日本語",
  [LANGUAGES.EN]: "英語",
  [LANGUAGES.CN]: "中国語",
};

export const RECEIVE_NEWS_LETTERS = {
  false: "希望しない",
  true: "希望する",
};

export const NOTICES = {
  false: "設定しない",
  true: "設定する",
};
